import { useCallback, useEffect, useMemo } from "react";

import { useLocation } from "react-router-dom";

import {
  useDateRangeQueryState,
  DateRangeQueryParam,
} from "@hooks/query-params/use-date-range-query";
import {
  type FixedDateInterval,
  todayLocalAsISODate,
  type DateRangeChoiceV2,
  type ICompareDateRangeEnum,
  resolveCompareDateRange,
  type ITimeGranularityV2,
} from "@north-beam/nb-common";
import { parseDateRangeArgument } from "@utils/index";

export const useReportBodyState = () => {
  const location = useLocation();
  const [state, setState] = useDateRangeQueryState();

  useEffect(() => {
    if (location.search === "") {
      setState(state);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const dateRange = useMemo(
    () => parseDateRangeArgument(state.dateRange, todayLocalAsISODate()),
    [state],
  );

  return {
    state,

    timeGranularity: state.timeGranularity,
    setTimeGranularity: useCallback(
      (value: ITimeGranularityV2) =>
        setState({ [DateRangeQueryParam.TIME_GRANULARITY]: value }),
      [setState],
    ),

    dateRange,
    setDateRange: useCallback(
      (value: FixedDateInterval | DateRangeChoiceV2) =>
        setState({ [DateRangeQueryParam.DATE_RANGE]: value }),
      [setState],
    ),

    compareDateRange: useMemo(
      () => resolveCompareDateRange(dateRange, state.compareDateRange),
      [dateRange, state.compareDateRange],
    ),
    setCompareDateRange: useCallback(
      (value: FixedDateInterval | ICompareDateRangeEnum) =>
        setState({ [DateRangeQueryParam.COMPARE_DATE_RANGE]: value }),
      [setState],
    ),
  };
};
